import VENDOR_LIST from "./venderList";

export default VENDOR_LIST;
